import { render, staticRenderFns } from "./TemplateReportPushNotificationOpenings.vue?vue&type=template&id=07b5d843&scoped=true"
import script from "./TemplateReportPushNotificationOpenings.vue?vue&type=script&lang=js"
export * from "./TemplateReportPushNotificationOpenings.vue?vue&type=script&lang=js"
import style0 from "./TemplateReportPushNotificationOpenings.vue?vue&type=style&index=0&id=07b5d843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b5d843",
  null
  
)

export default component.exports